import React, { useRef, useState } from "react";
import "./Comment.css";
import { MdOutlineBookmarkAdd, MdMoreHoriz } from "react-icons/md";
import { Link } from "react-router-dom";
import Modal from "../../Saqlangan/Modal";
import { Checkbox } from "@mui/material";
import {MdOutlineDoNotDisturb} from "react-icons/md"

export default function Comment({
  setNewList,
  obj,
  mainArr,
  setMainArr,
  saved,
  setSaved,
  newList,
  setSavedToList,
  savedToList,
}) {
  let [checked, setChecked] = useState(false);
  let [inpCheck, setInpCheck] = useState(false);
  let [back, setBack] = useState(false);

  const [addWindow, setAddWindow] = useState(false);
  const [inputVal, setInputVal] = useState("");

  const [checkBox, setCheckbox] = useState(true);
  const [showMore, setShowMore] = useState(false)

  const checkboxHand = (id) => {
    setCheckbox(false);
    let newSaved = savedToList.filter((item) => {
      return id !== item.id;
    });
    setSavedToList(newSaved);
    setInpCheck(false);
  };

  const savedHandler = (obj1) => {
    setChecked(!checked);
    if (savedToList.indexOf(obj1) !== -1) return;
    setSavedToList([...savedToList, obj1]);

    setInpCheck(true);
    setBack(true);
  };
  let darkBackHandler = () => {
    setBack(false);
    setChecked(false);
    setCheckbox(true);
    setShowMore(false)

  };

  const addWindowHandler = () => {
    setAddWindow(true);
  };

  const closeModalHandler = () => {
    setAddWindow(false);
    setCheckbox(false)
  };

  const addNewListHandler = () => {
    setAddWindow(false);
    setNewList([...newList, { name: inputVal }]);
    setCheckbox(false)
    setSaved([...saved, { name: inputVal }]);
  };

  const changeHandler = (e) => {
    setInputVal(e.target.value);
  };

  const showMoreHandler = () => {
    setShowMore(!showMore)
    setBack(true)
  }

  return (
    <div className="li">
      <li className="comment">
        <div
          onClick={darkBackHandler}
          className={`backdark ${back ? "backdark-show" : "backdark"}`}
        ></div>
        <div className="com-name">
          <div className="name-avatar">
            <img src={obj.avatar} alt="img" />
            <h5>{obj.name}</h5>
            <p>{obj.data}</p>
          </div>
          <div className="desc">
            <Link to={`${obj.id}`}>
              <h3>{obj.title}</h3>
              <p className="ppp">{obj.decs}</p>
            </Link>

            <div className="underdoge">
              <div className="first-btns">
                <button className="btn-active">Self inprovement</button>
                <button>{obj.read}</button>
                <button>Popular in medium</button>
              </div>

              <div className="book-div">
                <button
                  className={`bookmar ${inpCheck ? "green" : ""}`}
                  onClick={() => savedHandler(obj)}
                >
                  <MdOutlineBookmarkAdd />
                </button>
                <button className="btn-rel" onClick={showMoreHandler}>
                  <MdMoreHoriz />

                  <div className={`more-absolute ${showMore? "more-absolute-show" : ""}`}>
                    <ul>
                      <li className="li-flex"><MdOutlineDoNotDisturb />Show less like this</li>
                      <hr />
                      <li>Mute this Author</li>
                      <li>Mute this publication</li>
                      <li>Report</li>
                    </ul>
                  </div>
                </button>

                <Modal
                  changeHandler={changeHandler}
                  inputVal={inputVal}
                  closeModalHandler={closeModalHandler}
                  addNewListHandler={addNewListHandler}
                  addWindow={addWindow}
                />

                <div
                  className={`btn-small-modal ${
                    checked ? "btn-small-modal-show" : ""
                  }`}
                >
                  <div className="check-flex">
                    <div className="block">
                      <div className="in-flex">
                        <Checkbox
                          onChange={() => checkboxHand(obj.id)}
                          type="checkbox"
                          checked={checkBox ? true : false}
                          color="success"
                          id="check"
                        />
                        <label htmlFor="check">Reading List</label>
                      </div>

                      {saved.map((item, i) => {
                        return (
                          <div key={i} className="inp-div">
                            <Checkbox type="checkbox" color="success" />
                            <label className="p">{item.name}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button className="create-list" onClick={addWindowHandler}>
                    Create new List
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right-img">
          <img src={obj.img} alt="img" />
        </div>
      </li>
    </div>
  );
}
